// Shared input types for design-system primitives. Values map 1:1 onto
// the spacing tokens defined in src/styles/tokens.scss.

export type BvSpace =
  | "0"
  | "0-5"
  | "1"
  | "1-5"
  | "2"
  | "3"
  | "4"
  | "5"
  | "6"
  | "8"
  | "10"
  | "12"
  | "16"
  | "20";

export type BvAlign = "start" | "center" | "end" | "stretch" | "baseline";

export type BvJustify =
  | "start"
  | "center"
  | "end"
  | "between"
  | "around"
  | "evenly";

export function spaceVar(space: BvSpace): string {
  return `var(--space-${space})`;
}

export function alignToCss(align: BvAlign): string {
  if (align === "start") return "flex-start";
  if (align === "end") return "flex-end";
  return align;
}

export function justifyToCss(justify: BvJustify): string {
  if (justify === "start") return "flex-start";
  if (justify === "end") return "flex-end";
  if (justify === "between") return "space-between";
  if (justify === "around") return "space-around";
  if (justify === "evenly") return "space-evenly";
  return justify;
}
